export const formatLikesCount = (count: number): string => {
  if (!Number.isFinite(count)) return "0";

  if (count < 1000) return String(count);

  const format = (value: number, suffix: string): string => {
    const rounded = Math.floor(value * 10) / 10;
    return rounded % 1 === 0 ? `${rounded.toFixed(0)}${suffix}` : `${rounded}${suffix}`;
  };

  if (count < 1_000_000) {
    return format(count / 1_000, "k");
  }

  if (count < 1_000_000_000) {
    return format(count / 1_000_000, "M");
  }

  return format(count / 1_000_000_000, "B");
};
